/*
 *		Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .directive('accFilesCloudApplicationSwitcher', [
        'CloudPlatformUserInfo',
        'ENV',
        'template',
        function (CloudPlatformUserInfo, ENV, template) {
            const iconMap = {
                'platform': 'i-website-o--24', // Management Portal
                'backup': 'i-backup-dr-o--24', // Cyber Protection
                'physical_data_shipping': 'i-to-cloud-o--24', // Physical Data Shipping
                'notary': 'i-notary-o--24', // Notary
                'omnivoice': 'i-omnivoice-o--24', // Omnivoice
                'greathorn': 'i-greathorn-o--24', // GreatHorn Cloud Email Security
                'unknown': 'i-services-o--24' // Unknown
            };

            return {
                replace: true,
                scope: {},
                templateUrl: template('account/files_cloud_application_switcher'),
                controller: ['$scope', function ($scope) {
                    $scope.applications = [];

                    CloudPlatformUserInfo.getApplications()
                        .then(function (applications) {
                            $scope.applications = applications.map(function (item) {
                                return {
                                    name: item.name,
                                    address: item.api_base_url,
                                    icon: iconMap[item.type] || iconMap.unknown
                                };
                            });
                        });
                }]
            };
        }]);
